import { createSlice } from "@reduxjs/toolkit";




const userSlice = createSlice({
    name: 'userSlice',
    initialState: {
        login: localStorage.getItem("user-info") !== null

    },

    reducers: {
        setLogin(state, { payload }) {
            state.login = payload;
        },
    }
})

export default userSlice;

export const userActions = userSlice.actions;